import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo, useRef } from "react";
import { addColourModifiers } from "./utils/addColourModifiers";
import { createNamedContext } from "../createNamedContext";
export const CSSCustomPropertyContext = createNamedContext("cssCustomProperty", {});
export const CSSCustomPropertyContextProvider = ({ properties = {}, children, displayMode = "contents", }) => {
    const nodeRef = useRef(null);
    const inheritedProperties = useContext(CSSCustomPropertyContext);
    const modifiedProperties = useMemo(() => addColourModifiers(properties), [properties]);
    const styles = useMemo(() => ({ display: displayMode, ...modifiedProperties }), [modifiedProperties, displayMode]);
    return (_jsx(CSSCustomPropertyContext.Provider, { value: { ...inheritedProperties, ...modifiedProperties }, children: _jsx("div", { ref: nodeRef, style: styles, children: children }) }));
};
